<router-outlet></router-outlet>

<app-http-error-message></app-http-error-message>
